import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { userManager } from '@/lib/oidc-config';

export const Route = createFileRoute('/logout')({
  component: () => {
    useEffect(() => {
      (async () => {
        const search = new URLSearchParams(window.location.search);
        const returnUrl = search.get('returnUrl') || '/';
        sessionStorage.setItem('postLogoutReturnUrl', returnUrl);

        // Force the IdentityServer UI logout with an explicit returnUrl so redirect is guaranteed
        const authority = (userManager as any).settings?.authority || '';
        const absReturn = `${window.location.origin}${returnUrl.startsWith('/') ? returnUrl : '/' + returnUrl}`;
        if (authority) {
          try { await userManager.removeUser(); } catch {}
          window.location.href = `${authority.replace(/\/$/, '')}/Identity/Logout?returnUrl=${encodeURIComponent(absReturn)}`;
          return;
        }
      })();
    }, []);
    return null; // or a small "Signing out..." UI
  },
});